export default __webpack_public_path__ + "static/media/nothingWaw.54c10320.gif";